import { render, staticRenderFns } from "./SelecionarPrazo.vue?vue&type=template&id=05f734b9&scoped=true&"
import script from "./SelecionarPrazo.vue?vue&type=script&lang=js&"
export * from "./SelecionarPrazo.vue?vue&type=script&lang=js&"
import style0 from "./SelecionarPrazo.vue?vue&type=style&index=0&id=05f734b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f734b9",
  null
  
)

export default component.exports